import pipe1 from "./pipe1.js";
import reduce from "./reduce.js";
function pipe(a, ...fns) {
    return reduce(pipe1, a, fns);
}
export default pipe;
//# sourceMappingURL=pipe.js.map